export const ShareLink = () => {
	$(document).ready(function () {
		const url = window.location.href;

		$('.tw').on('click', function (e) {
			e.preventDefault();
            let handles = $(this).attr('data-handles');
            let description = handles ? `by ${handles} via @lightspeedvp` : 'by @lightspeedvp';

			openWindow(
				'https://twitter.com/intent/tweet?text=' + encodeURIComponent(url + ' ' + description),
				'_blank'
			);
			//openWindow('https://twitter.com/share?url=' + url, '_blank');
		});

		$('.fb').on('click', function (e) {
			e.preventDefault();
			openWindow('https://www.facebook.com/sharer/sharer.php?u=' + url, '_blank');
		});

		$('.li').on('click', function (e) {
			e.preventDefault();
			openWindow(
				'https://www.linkedin.com/sharing/share-offsite/?url=' + url,
				'_blank'
			);
		});

		$('.share-link').on('click', function (e) {
			e.preventDefault();
			copy(url, e.currentTarget);
		});

	});

	function openWindow(url, target) {
		if (isMobileDevice()) {
			window.open(url, target);
		} else {
			window.open(
				url,
				'',
				'width=550,height=400,resizable=yes,scrollbars=yes,top=200,left=200'
			);
		}
	}

	function isMobileDevice() {
		return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
			navigator.userAgent
		);
	}

	function copy(url, target) {
		const input = document.createElement("input");
		input.setAttribute("value", url);
		target.appendChild(input);
		input.select();
		const result = document.execCommand("copy");
		target.removeChild(input);
		return result;
	}
};